import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ECreditApplicationStatus } from '@if/core/types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import SectionTitle from '../PageSectionTitle';
const ClosedApplicationTile = ({ status, targetPath }) => {
    const navigate = useNavigate();
    const { t } = useTranslation('shared');
    return (_jsxs("main", { className: "general-message", style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            padding: '2rem 1rem',
        }, children: [_jsx(SectionTitle, { title: t('common.financeApplication') }), status === ECreditApplicationStatus.Completed && (_jsx("h3", { style: { marginBottom: '2rem', textAlign: 'center' }, children: t('common.completedTitle') })), _jsx("p", { className: "black-strong", style: {
                    fontSize: 20,
                    margin: 0,
                    textAlign: 'center',
                }, children: t(`common.${status}`) }), _jsx("div", { className: "btn-group full-width-mobile", style: {
                    marginTop: '2.5rem',
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                }, children: _jsxs("button", { type: "button", className: "btn btn-blue primary-action-btn", style: { minWidth: 220 }, onClick: () => navigate(targetPath, { replace: true }), children: [_jsx("span", { children: t('common.newApplication') }), _jsx("i", { className: "fa-regular fa-paper-plane-top" })] }) })] }));
};
export default ClosedApplicationTile;
